import React from 'react'
import PropTypes from 'prop-types'
import isFunction from 'lodash/isFunction'
import { connect } from 'react-redux'
import { getBoundActions } from 'actions'
import IconV2, { ICON_TYPES } from 'components/Icon.v2'
import Button, { TYPES } from 'components/Button'

class AlertBar extends React.Component {
  componentDidMount () {
    const { setAlertBarVisible } = this.props
    setAlertBarVisible(true)
  }

  onDismiss = (e) => {
    const { props } = this
    const { onDismiss, setAlertBarVisible, setAlertBarDismissed } = props
    setAlertBarVisible(false)
    setAlertBarDismissed(true)
    if (isFunction(onDismiss)) {
      onDismiss(e)
    }
  }

  render () {
    const { props, onDismiss } = this
    const {
      error,
      dismissable,
      children,
      className,
    } = props
    const baseClass = error ? ['alert-bar', 'alert-bar-error'] : ['alert-bar']

    if (dismissable) {
      baseClass.push('alert-bar-dismissable')
    }
    if (className) {
      baseClass.push(className)
    }
    const classes = baseClass.join(' ')

    return (
      <div className={classes} aria-live="assertive" role="alert">
        {dismissable ? (
          <Button
            type={TYPES.LINK}
            onClick={onDismiss}
            className="alert-bar__close-button"
          >
            <IconV2
              className="alert-bar__close-icon"
              type={ICON_TYPES.CLOSE}
            />
          </Button>
        ) : null}
        { children }
      </div>
    )
  }
}

AlertBar.propTypes = {
  setAlertBarDismissed: PropTypes.func.isRequired,
  setAlertBarVisible: PropTypes.func.isRequired,
  dismissable: PropTypes.bool,
  onDismiss: PropTypes.func,
  children: PropTypes.node,
  error: PropTypes.bool,
  className: PropTypes.string,
}

export default connect(
  null,
  (dispatch) => {
    const actions = getBoundActions(dispatch)
    return {
      setAlertBarVisible: actions.alertBar.setAlertBarVisible,
      setAlertBarDismissed: actions.alertBar.setAlertBarDismissed,
    }
  },
)(AlertBar)
